var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-badge',{staticClass:"pill",attrs:{"color":_vm.color,"isSolid":_vm.isSolid,"value":_vm.value,"size":_vm.size,"fontFamily":"mono"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }